import SMS from './SMS';

export default SMS;
